/**
 * Cliente API de Depósitos a Plazo (DAP) — Bloque 2 tesorería 2026-06.
 * Tab "Depósitos" dentro de la vista Banco.
 */
import { apiFetch } from './client';

export interface DepositoAPlazo {
  id: string;
  banco: string;
  capital: number;
  fecha_apertura: string; // YYYY-MM-DD
  plazo_dias: number;
  fecha_vencimiento: string; // YYYY-MM-DD
  tasa_bps: number | null; // puntos base (100 = 1%)
  renovable: boolean;
  folio: string | null;
  estado: 'vigente' | 'liquidado';
  fecha_liquidacion: string | null;
  interes_ganado: number | null;
  notas: string | null;
  creado_at: string;
}

export interface DepositosResumenResponse {
  depositos: DepositoAPlazo[];
  total_vigente: number;
}

export interface CrearDepositoIn {
  banco: string;
  capital: number;
  fecha_apertura: string; // YYYY-MM-DD
  plazo_dias: number;
  fecha_vencimiento?: string | null;
  tasa_bps?: number | null;
  renovable: boolean;
  folio?: string | null;
  notas?: string | null;
}

export interface LiquidarDepositoIn {
  fecha_liquidacion?: string | null;
  interes_ganado: number;
  notas?: string | null;
}

export function listDepositos(): Promise<DepositosResumenResponse> {
  return apiFetch<DepositosResumenResponse>('/tesoreria/depositos/');
}

export function crearDeposito(data: CrearDepositoIn): Promise<DepositoAPlazo> {
  return apiFetch<DepositoAPlazo>('/tesoreria/depositos/', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function liquidarDeposito(
  id: string,
  data: LiquidarDepositoIn,
): Promise<DepositoAPlazo> {
  return apiFetch<DepositoAPlazo>(`/tesoreria/depositos/${id}/liquidar`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
